module.exports = __webpack_public_path__ + "static/avatar-31ccec2ede5e81c8acc582de3216780d.jpg";